var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u6296\u97F3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9996\\u9875",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6296\\u97F3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    fill: "#000000",
    opacity: 0.05,
    cx: 17.5,
    cy: 17.5,
    r: 17.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5509576,15.8328821 C23.9613903,15.8328821 22.4153704,15.3162727 21.1436692,14.3605926 L21.1436692,21.0273138 C21.1436692,24.4316846 18.5209067,27.1887797 15.2850018,27.1887797 C12.0490731,27.1887797 9.42631063,24.4316846 9.42631063,21.0273138 C9.42631063,17.6230377 12.0490731,14.8658243 15.2850018,14.8658243 C15.6085686,14.8658243 15.9227447,14.8942804 16.2293278,14.9472423 L16.2293278,18.4783763 C15.9359438,18.3628725 15.623731,18.3043045 15.3095785,18.3043045 C13.8657452,18.3043045 12.6943854,19.5343269 12.6943854,21.0538303 C12.6943854,22.5714886 13.8657452,23.803356 15.3095785,23.803356 C16.7515669,23.803356 17.922903,22.5714886 17.922903,21.0538303 L17.922903,7.8112203 L21.1909778,7.8112203 C21.1909778,10.3564677 23.1533602,12.419097 25.5736894,12.419097 L25.5736894,15.8309424 L25.5509576,15.8328821",
    id: "Fill-1",
    fill: "#14161E",
    fillRule: "nonzero"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.svg";
export { ForwardRef as ReactComponent };